import { Link } from 'react-router-dom'
import styled from 'styled-components'
import { colors, fontWeights } from '@/styles'

const Anchor = styled(Link)<{ left?: number | string; disabled?: boolean }>`
  color: ${colors.link};
  font-weight: ${fontWeights.regular};

  ${props =>
    props.left &&
    `
    margin-left: ${props.left}px;
  `}
`

export default Anchor
